<template>
  <el-dialog
    :visible="visible"
    :title="$t('CargoMsg.Cargo_SelectTheApprovalPosition')"
    :before-close="cancel"
    width="660px"
    append-to-body
  >
    <div class="grid">
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="workflowTypes"
        style="width:100%;min-height: 400px"
      />
    </div>
    <template slot="footer">
      <div>
        <el-button type="primary" @click="onSave">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button @click="cancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </template>
    <bill-payment-apply-form
      :visible="fromDialog.visible"
      :workflow-title="fromDialog.name"
      @close="fromDialog.visible=false"
    />
  </el-dialog>
</template>

<script>
import BillPaymentApplyForm
  from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcess/billPaymentApplyForm'
import * as WorkflowConstants from '@/class/cargo/model/parameters/WorkflowConstants'
import { DocumentManage } from '@/utils/commonUtil'
export default {
  name: 'BindApprovalTemplateDialog',
  components: { BillPaymentApplyForm },
  props: {
    visible: { type: Boolean, default: () => false }
  },
  data() {
    return {
      documentManage: new DocumentManage(),
      workflowTypes: Array.from(WorkflowConstants.WORKFLOW_TYPES),
      fromDialog: {
        visible: false,
        name: ''
      },
      selectRow: null,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: event => {
          this.selectRow = event.data
        }
      },
      columnDefs: [
        {
          headerName: this.$t('Template.TemplateName'), field: 'chineseName', colId: 'chineseName', flex: 1
        },
        {
          headerName: this.$t('SeaExport.Operation'), field: 'code', colId: 'code', flex: 1,
          cellRenderer: params => {
            const showDetailFrom = this.documentManage.getPath('toShowDetailFrom')
            return `<div onclick="${showDetailFrom}(${params.value}, '${params.data.chineseName}')" style="display: inline-block;color:dodgerblue;margin-right: 5px;cursor: pointer">${this.$t('FileHistory.preview')}</div>`
          }
        }
      ]
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('toShowDetailFrom', function(code, name) {
      context.toShowDetailFrom(code, name)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    onSave() {
      if (!this.selectRow) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseChooseData'))
        return
      }
      this.$emit('choose', this.selectRow.code)
      this.$emit('close')
    },
    cancel() {
      this.$emit('close')
    },
    toShowDetailFrom(code, name) {
      this.fromDialog.visible = true
      this.fromDialog.name = name
    }
  }
}
</script>

<style scoped>

</style>
